<template>
  <div class="illustration-style-content" id="identidade-visual-ilustracao-estilo" data-search-anchor>
    <div class="illustration-title-style-wrapper">
      <h1 class="illustration-style-title-span">{{ illustrationStyleTitleSpan }}</h1>
      <h1 class="illustration-style-title">{{ illustrationStyleTitle }}</h1>
    </div>
    <div class="illustration-description-style-wrapper">
      <p class="illustration-style-description">{{ illustrationStyleDescription }}</p>
      <div class="icon-wrapper">
        <IconCheck />
        <p class="illustration-style-description-icon">{{ illustrationStyleDescription1 }}</p>
      </div>

      <div class="icon-wrapper">
        <IconCheck />
        <p class="illustration-style-description-icon">{{ illustrationStyleDescription2 }}</p>
      </div>

      <div class="icon-wrapper">
        <IconCheck />
        <p class="illustration-style-description-icon">{{ illustrationStyleDescription3 }}</p>
      </div>

      <div class="icon-wrapper">
        <IconCheck />
        <p class="illustration-style-description-icon">{{ illustrationStyleDescription4 }}</p>
      </div>
    </div>
    <div
      class="illustration-style-card-item"
      :style="{ backgroundImage: `url(${illustrationStyleImageSrc})` }"
    ></div>
  </div>
</template>

<script lang="ts">
import IconCheck from '@/assets/icons/IconCheck.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import IllustrationPageMixin from '@/mixins/illustration-page-mixin'
import { IllustrationPageStore } from '@/store/visual-identity-page/illustration-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({ components: { IconCheck } })
export default class IllustrationStyleSection extends Mixins(IllustrationPageMixin) {
  illustrationPageStore: PageStoreContract = getModule(IllustrationPageStore, this.$store)

  get illustrationStyleTitleSpan(): string {
    return this.getElementTitle(2, 0)
  }

  get illustrationStyleTitle(): string {
    return this.getElementText(2, 0)
  }

  get illustrationStyleDescription(): string {
    return this.getElementText(2, 1)
  }

  get illustrationStyleDescription1(): string {
    return this.getElementText(2, 2)
  }

  get illustrationStyleDescription2(): string {
    return this.getElementText(2, 3)
  }

  get illustrationStyleDescription3(): string {
    return this.getElementText(2, 4)
  }

  get illustrationStyleDescription4(): string {
    return this.getElementText(2, 5)
  }

  get illustrationStyleImageSrc(): string {
    return this.getElementMedia(2, 6)
  }

  async getIllustrationPage(): Promise<void> {
    await this.illustrationPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.illustrationPageStore.isLoading) {
      await this.getIllustrationPage()
    }
  }
}
</script>

<style lang="scss">
.illustration-style-content {
  display: grid;

  width: 100%;
  max-width: 1032px;
}

.illustration-title-style-wrapper {
  display: flex;
  align-items: center;
  height: 6vh;
  padding-top: 6.25rem;
  padding-bottom: 1rem;
}

.illustration-style-title-span {  
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  margin-right: 5px;
  color: #b3b3b3;
}

.illustration-style-title {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  color: #000000;
}

.illustration-description-style-wrapper {  
  position: relative;  

  display: grid;
  grid-template-columns: 50% 50%;  
}

.illustration-style-description-icon,
.illustration-style-description {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;

  padding-left: 7px;  
  width: 378px;
}

.illustration-style-description {  
  padding-left: 0;
  width: 430px;
}

.illustration-style-card-item {
  position: relative;
  
  max-width: 1032px;
  width: 100%;
  height: 580px;
  border-radius: 12px;

  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
</style>
